enum ReasoningEffort {
  None = "none",
  Low = "low",
  Medium = "medium",
  High = "high",
  XHigh = "xhigh",
}
export default ReasoningEffort;
